import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';
import Handlebars from 'handlebars';
import ServiceMapLocationsPartialTemplate from 'js/templates/partials/service.mapLocations.partial.hbs';
import {_, Backbone} from "backboneAdapter";
import gMaps from 'gMaps';


export default Backbone.View.extend({
    el: "#passLocations",
    tagName: "div",
    currentMarkerOnMap: {marker: null, index: -1}, //current Marker on the map, `if (index == -1) ===> marker is not saved`
    markers: null, //saved markers
    map: null,
    geocoder: null,
    template: Handlebars.compile(ServiceMapLocationsPartialTemplate),
    pos: { //default map center, greece
        lat: 39.0186437,
        lng: 27.6722559
    },
    mapOptions: {
        center: new gMaps.LatLng(39.0186437, 27.6722559),
        zoom: 5,
        mapTypeId: gMaps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false
    },
    voucherId: null,
    voucherCampaignId: null,
    initialize: function (options) {
        var self = this; //this refers to `it`
        this.ccView = options.ccView;

        this.voucherId = this.ccView.model.id;
        this.voucherCampaignId = this.ccView.model.attributes.campaignId;
        if (options && options.markers) {
            this.fillMarkers(options.markers);
        } else {
            this.markers = [];
        }
        this.geocoder = new gMaps.Geocoder();
        this.render();
    },
    render: function () {
        var self = this;
        this.$el.html(this.template(this.ccView.model.toJSON()));
        this.rewireButtonEvents(); //rewires button events (editMarker/deleteMarker/saveMarker)
        if (this.markers.length === 0) {
            $("#passLocations").parent().hide();
            $("#noMapLocationsExist").show();
        } else {
            $("#passLocations").parent().show();
            $("#noMapLocationsExist").hide();
        }
    },
    renderMap: function () {
        var self = this;
        this.map = new gMaps.Map(document.getElementById("map"), this.mapOptions);
        if (this.voucherCampaignId === 0) {
            this.rewireMapEvents(); //needed since google "clears" map when the container DIV is getting hidden
        }

        var $markerTitleInput = $("#displayedAddress");
        $markerTitleInput.data("attr", "voucherPageConfig.mapLocations[" + this.currentMarkerOnMap.index + "]");

        //hide current marker on map, if it exists
        this.clearMap();
        this.showMap();
    },
    events: {},
    rewireButtonEvents: function () {
        var self = this;

        //rewire events, since we update the template
        if (this.voucherCampaignId === 0) {
            $(".editMapLocation").unbind("click").on("click", function (evt) {
                self.editMarkerClicked(evt);
            });
            $(".removeMapLocation").unbind("click").on("click", function (evt) {
                self.removeMarkerClicked(evt);
            });
            $("#saveNewMarker").unbind("click").on("click", function (evt) {
                self.saveMarkerClicked(evt);
            });
            $("#updateMarker").unbind("click").on("click", function (evt) {
                self.updateMarkerClicked(evt);
            });
            $(".mapLocationSearchbox").unbind("keyup").on("keyup", function (evt) {
                self.searchForAddress(evt);
            });
        } else { //already executed campaign
            $(".showMapLocation").unbind("click").on("click", function (evt) {
                self.showMarkerClicked(evt);
            });
        }
    },
    rewireMapEvents: function () {
        var self = this;
        gMaps.event.addListener(this.map, 'click', function (event) {
            self.placeMarkerOnMap(event.latLng);
        });
    },
    placeMarkerOnMap: function (latLng) {
        var self = this;
        //if (index > -1) ==> we're editing an existing marker
        if (this.currentMarkerOnMap.marker || (this.currentMarkerOnMap.marker && this.currentMarkerOnMap.index > -1)) {
            this.currentMarkerOnMap.marker.setPosition(latLng);  //moves the existing marker on map
        } else { //create a new marker
            this.currentMarkerOnMap.marker = new gMaps.Marker({
                position: latLng,
                map: self.map
            });
        }
    },
    searchForAddress: _.debounce(function (e) {
        var self = this;
        var input = $(e.currentTarget);

        var searchText = input.val();
        this.geocoder.geocode({'address': searchText}, function (results, status) {
            if (status === gMaps.GeocoderStatus.OK) {
                var formattedAddress = results[0].formatted_address;

                self.map.panTo(results[0].geometry.location);
                if (self.currentMarkerOnMap.marker) {
                    self.placeMarkerOnMap(results[0].geometry.location);
                } else {
                    self.currentMarkerOnMap.marker = new gMaps.Marker({
                        map: self.map,
                        position: results[0].geometry.location
                    });
                }
                $("#displayedAddress").find("input").val(formattedAddress);
                self.currentMarkerOnMap.marker.setTitle(formattedAddress);
            } else {
                $.Notify.warn(i18n.t("map.geocodefail") + "!");
            }
        });
    }, 800),
    getMarker: function (index) {
        if (!this.markers || !this.markers[index]) {
            return null;
        }
        return this.markers[index];
    },
    showMap: function () {
        $("#mapContainer").show();
        gMaps.event.trigger(this.map, 'resize'); //trigger resize event, so the map will be redrawn (since google clears the container, when it is set 'hidden')

        $("#mapLocationSearchbox").find("input").val("");
        if (this.currentMarkerOnMap.marker) {
            $("#displayedAddress").find("input").val(this.currentMarkerOnMap.marker.getTitle());
        }
    },
    hideMap: function () {
        $("#mapContainer").hide();
    },
    showMarker: function (index) {
        this.currentMarkerOnMap.marker = this.getMarker(index);
        if (this.currentMarkerOnMap.marker) {
            this.currentMarkerOnMap.marker.setMap(this.map);
            this.currentMarkerOnMap.index = index; //keep the index, so that we know which marker is currently on Map
            this.map.setCenter(this.currentMarkerOnMap.marker.position);
            return;
        }
        $.Notify.error(i18n.t('voucher.selectedMarkerNotExists'));
    },
    clearMap: function () {
        if (this.currentMarkerOnMap.marker) {
            this.currentMarkerOnMap = {marker: null, index: -1};
            //clear the inputs
            $("#displayedAddress").find("input").val("");
            $("#mapLocationSearchbox").find("input").val("");
        }
    },
    editMarkerClicked: function (e) {
        var self = this;
        var $currentTarget = $(e.currentTarget);
        var index = $currentTarget.data("index");

        if (!this.markers || !this.markers[index]) {
            $.Notify.error(i18n.t('voucher.selectedMarkerNotExists'));
        } else {
            $('#updateMarker').show();
            $('#saveNewMarker').hide();
            this.renderMap(); //renderMap clears the map, of markers
            this.showMarker(index);

            $("#displayedAddress").find("input").val(this.currentMarkerOnMap.marker.getTitle());
        }
    },
    updateMarkerClicked: function () { //update button clicked
        var self = this;
        //check if the map has a marker on it (if not, user did not edit any location)
        var mapHasMarker = self.currentMarkerOnMap.marker && self.currentMarkerOnMap.marker.getMap();
        var index = self.currentMarkerOnMap.index;

        if (!self.markers || !self.markers[index] || !mapHasMarker) {
            $.Notify.error(i18n.t('voucher.selectedMarkerNotExists'));
            return;
        }

        var markerTitle = $("#displayedAddress").find("input").val(); //address to be displayed on the Phone Lock Screen

        if (markerTitle && markerTitle.trim().length > 0) {
            self.currentMarkerOnMap.marker.setTitle(markerTitle);
        } else {
            $.Notify.error(i18n.t('voucher.noAddressToBeDisplayedAdded'));
            return;
        }

        self.currentMarkerOnMap.marker.setTitle(markerTitle);
        var markerData = {
            "title": markerTitle,
            "position": {
                "lat": self.currentMarkerOnMap.marker.getPosition().lat(),
                "lng": self.currentMarkerOnMap.marker.getPosition().lng()
            }
        };

        var markerToBeUpdated = "mapLocation:com.msensis.middleware.utils.MapLocation:" +
            JSON.stringify(markerData);

        $.ajaxDefaultQ({
            url: "/CampaignCloud/Config/" + self.voucherId + "/voucherPageConfig.mapLocations/" + index,
            type: "PUT",
            data: markerToBeUpdated
        }).done(function (response) {
            if (response.outcome === "OK") {
                //update the marker in our Array and clean the current marker on map, since we will close it and do not longer need it
                self.markers[index] = new gMaps.Marker(markerData);

                self.updateModelMapLocationValues("update", index);

                self.clearMap();
                self.hideMap();

                self.render(); //updates data in the Map Location Rows (div with the list of the map locations)
                $.Notify.show(i18n.t("voucher.mapLocationUpdated"));
            } else {
                $.Notify.show(i18n.t("generic.=" + response.outcome));
            }
        }).fail(function (response) {
            console.error(response);
            $.Notify.error("Error: " + response);
        });
    },
    saveMarkerClicked: function () { //save button clicked
        var self = this;
        //check if the map has a marker on it (if not, user did not add any new location)
        var mapHasMarker = self.currentMarkerOnMap.marker && self.currentMarkerOnMap.marker.getMap();
        if (mapHasMarker && self.markers.length === 0) {
            //set the INDEX to `0` when there are no markers in the array
            self.currentMarkerOnMap.index = 0;
        } else {
            //set the INDEX to SELF.MARKERS.LENGTH value, so the insertion will be done in the last place of the list
            self.currentMarkerOnMap.index = self.markers.length;
        }
        var index = self.currentMarkerOnMap.index;

        if (!mapHasMarker) {
            $.Notify.error(i18n.t('voucher.noLocationSelected'));
            return;
        }

        var markerAlreadyExists = _.find(self.markers, function (marker) {
            return marker.getPosition().lng() === self.currentMarkerOnMap.marker.getPosition().lng() &&
                marker.getPosition().lat() === self.currentMarkerOnMap.marker.getPosition().lat();
        });
        if (markerAlreadyExists) {
            $.Notify.warn(i18n.t("voucher.mapLocationAlreadyExists"));
            return;
        }

        var markerTitle = $("#displayedAddress").find("input").val(); //address to be displayed on the Phone Lock Screen

        if (markerTitle && markerTitle.trim().length > 0) {
            self.currentMarkerOnMap.marker.setTitle(markerTitle);
        } else {
            $.Notify.error(i18n.t('voucher.noAddressToBeDisplayedAdded'));
            return;
        }

        var markerData = {
            "title": markerTitle,
            "position": {
                "lat": self.currentMarkerOnMap.marker.getPosition().lat(),
                "lng": self.currentMarkerOnMap.marker.getPosition().lng()
            }
        };

        var markerToBeSaved = "mapLocation:com.msensis.middleware.utils.MapLocation:" + JSON.stringify(markerData);

        $.ajaxDefaultQ({
            url: "/CampaignCloud/Config/" + self.voucherId + "/voucherPageConfig.mapLocations/" + index,
            type: "PUT",
            data: markerToBeSaved
        }).done(function (response) {
            if (response.outcome === "OK") {
                //update the marker in our Array and clean the current marker on map, since we will close it and do not longer need it
                self.markers.push(new gMaps.Marker(markerData));

                self.updateModelMapLocationValues("new", index);

                self.clearMap();
                self.hideMap();

                self.render(); //updates data in the Map Location Rows (div with the list of the map locations)
                $.Notify.show(i18n.t("voucher.newMapLocationAdded"));
            } else {
                $.Notify.show(i18n.t("generic.=" + response.outcome));
            }
        }).fail(function (response) {
            console.error(response);
            $.Notify.error("Error: " + response);
        });
    },
    showMarkerClicked: function (e) { //show selected Marker (Report Page)
        var $currentTarget = $(e.currentTarget);
        var index = $currentTarget.data("index");

        if (!this.markers || !this.markers[index]) {
            $.Notify.error(i18n.t('voucher.selectedMarkerNotExists'));
        } else {
            this.renderMap(); //renderMap clears the map, of markers
            this.showMarker(index);

            $("#displayedAddress").find("input").val(this.markers[index].getTitle());
        }
    },
    removeMarkerClicked: function (e) { //remove selected marker clicked
        var self = this;
        var $currentTarget = $(e.currentTarget);
        var index = $currentTarget.data("index");

        if (self.markers === self || !self.markers[index]) {
            $.Notify.error(i18n.t('voucher.selectedMarkerNotExists'));
            return;
        }

        dhtmlx.confirm({
            type: "confirm",
            title: i18n.t("survey.confirmdeletion"),
            text: i18n.t("voucher.deleteMapLocationPrompt"),
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
            callback: function (result) {
                if (result) {
                    $.ajaxDefaultQ({
                        url: "/CampaignCloud/Config/" + self.voucherId + "/voucherPageConfig.mapLocations/" + index,
                        type: "DELETE"
                    }).done(function (response) {
                        if (response.outcome === "OK") {
                            self.markers.splice(index, 1); //index and number of elements to remove

                            self.updateModelMapLocationValues("delete", index);

                            self.clearMap();
                            self.hideMap();

                            self.render(); //updates data in the Map Location Rows (div with the list of the map locations)
                            $.Notify.show(i18n.t("voucher.mapLocationRemoved"));
                        } else {
                            $.Notify.show(i18n.t("generic.=" + response.outcome));
                        }
                    }).fail(function (response) {
                        console.error(response);
                        $.Notify.error("Error: " + response);
                    });
                }
            }
        });
    },
    updateModelMapLocationValues: function (type, index) {
        var self = this;
        var voucherPageConfig = this.ccView.model.get("voucherPageConfig");
        var mapLocations = voucherPageConfig.get("mapLocations");

        if (type === "delete") {
            mapLocations.splice(index, 1);
        } else if (type === "update") {
            mapLocations[index] = {
                title: this.markers[index].getTitle(),
                position: {
                    lat: this.markers[index].getPosition().lat(),
                    lng: this.markers[index].getPosition().lng()
                }
            };
        } else if (type === "new") {
            var tempMarkerData = {
                title: this.markers[index].getTitle(),
                position: {
                    lat: this.markers[index].getPosition().lat(),
                    lng: this.markers[index].getPosition().lng()
                }
            };
            mapLocations.push(tempMarkerData);
        }

        voucherPageConfig.set("mapLocations", mapLocations);
        this.ccView.model.set("voucherPageConfig", voucherPageConfig);
        this.fillMarkers(mapLocations);
    },
    fillMarkers: function (markersArray) {
        //get the markers from `voucherPageConfig.mapLocations` and convert them to Google ones
        var self = this;

        self.markers = [];
        _.forEach(markersArray, function (markerOptions) {
            var marker = new gMaps.Marker(markerOptions);
            self.markers.push(marker);
        });
    }
});
